import { variables, $ } from '../common/variables';
import { cl, ajax, removeElement } from '../common/functions';

const fieldDelete = (elements) => {
  if (!!elements.length) {

    /*------------ [AJAX] function------------*/
    const action = 'delete_fields_ajax';

    /*------------ [AJAX] success------------*/
    const success = data => {
      if (data.table_exist) {
        if (data.confirmed_status) {
          if (data.table === `${variables.prefix}gl_categories_types`) {
            const element = document.querySelector(`#category__name--${data.id}`);
            if (element) {
              const container = element.parentNode.parentNode.parentNode;
              container.style.transition = "opacity 0.2s ease-in-out";
              container.style.opacity = "0";
              setTimeout(() => {
                removeElement(container);
              }, 400);
            }
          } else if (data.table === `${variables.prefix}gl_types`) {
            const element = document.querySelector(`#types__name--${data.id}`);
            if (element) {
              const container = element.parentNode.parentNode.parentNode;
              container.style.transition = "opacity 0.2s ease-in-out";
              container.style.opacity = "0";
              setTimeout(() => {
                removeElement(container);
              }, 400);
            }
          } else if (data.table === `${variables.prefix}gl_entities`) {
            const element = document.querySelector(`#entity__name--${data.id}`);
            if (element) {
              const container = element.parentNode.parentNode.parentNode.parentNode.parentNode;
              container.style.transition = "opacity 0.2s ease-in-out";
              container.style.opacity = "0";
              setTimeout(() => {
                removeElement(container);
              }, 400);
            }
          } else if (data.table === `${variables.prefix}gl_options`) {
            const element = document.querySelector(`#options_subcategory__name--${data.subcategory_counter}`);
            if (element) {
              const container = element.parentNode.parentNode.parentNode;
              container.style.transition = "opacity 0.2s ease-in-out";
              container.style.opacity = "0";
              setTimeout(() => {
                removeElement(container);
              }, 400);
            }
          }
        }
      } else {
        cl(`Table \n ${data.name} \n doesn't exist`);
      }
    };

    /*------------ [AJAX] error------------*/
    const error = err => {
      cl(err);
    };

    [...elements].forEach(element => {
      // prettier-ignore
      element.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const id = this.dataset.id,
          name = this.dataset.name,
          table = this.dataset.table,
          prefix = this.dataset.prefix,
          counter = this.dataset.counter,
          params = {
            action: action,
            id: id,
            name: name,
            table: table,
            prefix: prefix,
          };
        !!counter ? params.counter = counter : null;
        const warningPopup = (text, successText) => {
          cl(this);
          swal({
            title: "Information",
            text: text,
            icon: "warning",
            buttons: ["Non", "Oui"],
            dangerMode: false,
          })
            .then((willDelete) => {
              if (willDelete) {
                swal(successText, {
                  icon: "success",
                });
                setTimeout(() => {
                  ajax(params, success, error, 'json');
                }, 1000);
              }
            });
        }

        if (table === `${prefix}gl_categories_types`) {
          warningPopup("Attention, supprimer cette catégorie supprimera les types & magasins associés", "La categorie a bien été supprimée");
        } else if (table === `${prefix}gl_types`) {
          warningPopup("Attention, supprimer ce type supprimera également les magasins associés", "Le type a bien été supprimé");
        } else if (table === `${prefix}gl_entities`) {
          warningPopup("Voulez-vous vraiment supprimer ce magasin ?", "Le magasin a bien été supprimé");
        } else if (table === `${prefix}gl_options`) {
          warningPopup("Voulez-vous vraiment supprimer cette sous-catégorie ?", "La sous-catégorie a bien été surpprimée");
        }
      }, false);
    });
  }
}

export { fieldDelete };
